module.exports = __webpack_public_path__ + "img/sp-sort-button-up-disabled.aa827e3d.svg";